import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { BiArrowBack } from 'react-icons/bi';

import { objectToString } from 'helper';
import Card from 'partial/components/Card';
import Button from 'partial/components/Button';
import BusinessTypeOptions from '../components/BusinessTypeOptions';
import BusinessCorporation from './BusinessCorporation';
import BusinessIndividual from './BusinessIndividual';
import BusinessSole from './BusinessSole';
import BusinessGovernment from './BusinessGovernment';
import { useGeneralInfo, useSaveGeneralInfo } from '../hooks';

function BusinessInfo({ onNext, onBack }) {
  const [, data] = useGeneralInfo();
  const form = useMemo(() => ({ business_type: data?.business_type }), [data]);

  const ComponentForm = React.useMemo(
    () =>
      ({
        CORPORATION: BusinessCorporation,
        SOLE_PROPRIETORSHIP: BusinessSole,
        INDIVIDUAL: BusinessIndividual,
        GOVERNMENT: BusinessGovernment,
      }[form?.business_type]),
    [form?.business_type]
  );
  const [isLoading, submit] = useSaveGeneralInfo();
  const handleSetBusinessType = (v) => {
    const { business_type } = v();
    submit({
      ...data,
      logo: objectToString(data?.logo),
      business_type,
    });
  };
  const handleBack = () => {
    submit({
      ...data,
      logo: objectToString(data?.logo),
      business_type: '',
    });
  };

  if (ComponentForm) {
    return (
      <Card className="relative">
        <span className="absolute top-0 left-0 m-4">
          <Button transparent size="lg" icon={BiArrowBack} onClick={handleBack}>
            Change Business Type
          </Button>
        </span>
        <div className="p-12">
          {ComponentForm ? (
            <ComponentForm onNext={onNext} onBack={handleBack} />
          ) : null}
        </div>
      </Card>
    );
  }
  return (
    <Card className="relative">
      <span className="absolute top-0 left-0 m-4">
        <Button
          transparent
          size="lg"
          icon={BiArrowBack}
          onClick={() => onBack(data)}
        >
          Back
        </Button>
      </span>
      <div className="space-y-4 max-w-3xl mx-auto p-6">
        <div className="space-y-4">
          <div className="text-center space-y-3 w-3/5 mx-auto">
            <div className="title-h1 text-center">Business Information</div>
            <p>
              Provide more details about your business. We ask questions
              specific to your business type.
            </p>
          </div>
          <hr />
          <div className="font-semibold">Choose your type of business</div>
          <div>
            <BusinessTypeOptions
              disabled={isLoading}
              name="business_type"
              onChange={handleSetBusinessType}
              value={form.business_type}
            />
          </div>
        </div>
      </div>
    </Card>
  );
}

BusinessInfo.propTypes = {
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default BusinessInfo;
